import React from 'react';

/**
 * Helper to render subject with highlighted variables
 */
export const renderSubject = (subject: string): React.ReactNode => {
  // Regex to match {{variable}} patterns
  const parts = subject
    .split(/(\{\{[^}]+\}\})/g)
    .map((text, i) => ({ id: `${i}-${text}`, text }));

  return (
    <span className="break-words">
      {parts.map(({ id, text }) => {
        if (text.match(/^\{\{[^}]+\}\}$/)) {
          return (
            <span key={id} className="text-primary font-medium font-mono">
              {text}
            </span>
          );
        }
        return <span key={id}>{text}</span>;
      })}
    </span>
  );
};
